import VoiceCreditsLogs from '@/features/voice-credits-logs/VoiceCreditsLogsPage';
import { API_AI_AGENT_CREDITS_LOGS } from '@/service/url';

export default function AiAgentCreditsLogsPage() {
  return (
    <VoiceCreditsLogs
      logsApi={API_AI_AGENT_CREDITS_LOGS}
      pageTitle="AI Agent Voice Credits Logs"
      pageDescription="Additions and deductions of AI agent voice credits across companies."
      exportFileName="ai-agent-credits-logs"
      tableId="ai-agent-credits-logs.page"
    />
  );
}
